import { render, staticRenderFns } from "./InterviewCard.vue?vue&type=template&id=d2b01e82"
import script from "./InterviewCard.vue?vue&type=script&lang=js"
export * from "./InterviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports